import configs from './config.json';
import {Api} from "./Api";
import {UserApi} from "./UserApi";

export class CustomerApi {


    static getCustomers = async (response, error) => {
        await Api.get(`${configs.customer.base}`, null, response, UserApi.getAuthorizedHeader(), error);

    }
    static getCustomer = async (id, response, error) => {
        await Api.get(`${configs.customer.base}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);

    }


    static insertCustomer = async (data, response, error) => {
        await Api.post(`${configs.customer.base}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static updateCustomer = async (data, id, response, error) => {
        await Api.put(`${configs.customer.base}/${id}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static deleteCustomer = async (id, response, error) => {
        await Api.delete(`${configs.customer.base}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

    static activate = async (id, response, error) => {
        await Api.post(`${configs.customer.activate}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);
    }
    static deactivate = async (id, response, error) => {
        await Api.post(`${configs.customer.deactivate}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);
    }
}